import { isDefined } from "@omni/utils/helper.utils";
import { createContext, ReactNode, RefObject, use } from "react";

type SliderContextValue = {
    navigationPrevRef: RefObject<null | HTMLButtonElement>;
    navigationNextRef: RefObject<null | HTMLButtonElement>;
};

type SliderContextProviderProps = {
    navigationPrevRef: RefObject<null | HTMLButtonElement>;
    navigationNextRef: RefObject<null | HTMLButtonElement>;
    children: ReactNode;
};

export const SliderContext = createContext<SliderContextValue | undefined>(
    undefined
);

export const SliderContextProvider = ({
    navigationPrevRef,
    navigationNextRef,
    children
}: SliderContextProviderProps) => {
    return (
        <SliderContext.Provider
            value={{
                navigationPrevRef: navigationPrevRef,
                navigationNextRef: navigationNextRef
            }}
        >
            {children}
        </SliderContext.Provider>
    );
};

export const useSliderContext = () => {
    const context = use<SliderContextValue | undefined>(SliderContext);

    if (!isDefined(context)) {
        throw new Error(`${SliderContext.displayName} is undefined.`);
    }

    return context;
};
